export default new (class Accordion {
    constructor() {
        this.accordion = 'accordion';
        this.accordionContent = 'accordion-content';
        this.accordionBtn = 'accordion-btn';
        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {
            document.querySelectorAll(`.${this.accordionBtn}`).forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    item.closest(`.${this.accordion}`).classList.toggle('open')

                    if(item.closest(`.${this.accordion}`).classList.contains('open')) {
                        item.closest(`.${this.accordion}`).querySelector(`.${this.accordionContent}`).classList.remove('clump-5')
                        item.closest(`.${this.accordion}`).querySelector(`.${this.accordionContent}`).style.maxHeight = item.closest(`.${this.accordion}`).querySelector(`.${this.accordionContent}`).scrollHeight + 'px';
                    }
                    else {
                        setTimeout(() => {
                            item.closest(`.${this.accordion}`).querySelector(`.${this.accordionContent}`).classList.add('clump-5')
                        }, 350);
                        item.closest(`.${this.accordion}`).querySelector(`.${this.accordionContent}`).removeAttribute('style')
                    }
                });
            });
        });
    }
})()
